import * as React from 'react';
import { cn } from '@restworld/utils-common';
import { PersonWithRestworldCupIllustration } from '@restworld/utils-common/illustrations/cv-parsing-loading-illustration-final';
import { Heading } from '@restworld/ui-ds-base';
import { Button } from '@restworld/ui-ds-base';

export const ApplicationSuccessComponent = ({
  title,
  subTitle,
  buttonFirstTitle,
  buttonSecondTitle,
  onFirstButtonClick,
  onSecondButtonClick,
  variant = 'one',
}: {
  title: string;
  subTitle: string;
  buttonFirstTitle: string;
  buttonSecondTitle: string;
  onFirstButtonClick: () => void;
  onSecondButtonClick: () => void;
  variant?: 'one' | 'two';
}) => {
  return (
    <div className="flex flex-col gap-10">
      <SecondWrapperDiv isReversed={variant === 'two'}>
        <div className="[animation: scale-up-center 1s cubic-bezier(0.390, 0.575, 0.565, 1.000) both]">
          <PersonWithRestworldCupIllustration {...{ height: 300, width: 240 }} />
        </div>
        <div className="flex gap-2 flex-col max-w-sm">
          <Heading size={4} weight="semibold" className="leading-6.75">
            {title}
          </Heading>
          <Heading size={5} weight="normal" color="muted" className="leading-6">
            {subTitle}
          </Heading>
        </div>
      </SecondWrapperDiv>
      <div className="flex flex-col gap-2">
        <Button variant="primary" fullwidth onClick={onFirstButtonClick}>
          {buttonFirstTitle}
        </Button>
        <Button variant="secondary-neutral" fullwidth onClick={onSecondButtonClick}>
          {buttonSecondTitle}
        </Button>
      </div>
    </div>
  );
};
const SecondWrapperDiv = ({ isReversed, className, ...props }: any) => (
  <div
    className={cn(
      'flex flex-col gap-5 items-center text-center',
      isReversed ? 'flex-col-reverse' : 'flex-col',
      className
    )}
    {...props}
  />
);
